var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priority-item queue-complete" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-50" }, [
      _c("i", { staticClass: "fa fa-check queue-icon" }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Done")))]),
    ]),
    _vm._v(" "),
    _vm.isFreeUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get a subscription to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get Premium")))]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }